import { defineComponent as $, ref as w, computed as S, h as o } from "vue";
import { on as u, off as p } from "./ghl-ui.es694.js";
const l = "12px", r = "6px", C = $({
  name: "Pallete",
  props: {
    clsPrefix: {
      type: String,
      required: !0
    },
    rgba: {
      type: Array,
      default: null
    },
    // 0 - 360
    displayedHue: {
      type: Number,
      required: !0
    },
    displayedSv: {
      type: Array,
      required: !0
    },
    onUpdateSV: {
      type: Function,
      required: !0
    },
    onComplete: Function
  },
  setup(t) {
    const n = w(null);
    function h(e) {
      n.value && (u("mousemove", document, a), u("mouseup", document, s), a(e));
    }
    function a(e) {
      const {
        value: c
      } = n;
      if (!c)
        return;
      const {
        width: m,
        height: f,
        left: g,
        bottom: y
      } = c.getBoundingClientRect(), i = (y - e.clientY) / f, d = (e.clientX - g) / m, v = 100 * (d > 1 ? 1 : d < 0 ? 0 : d), b = 100 * (i > 1 ? 1 : i < 0 ? 0 : i);
      t.onUpdateSV(v, b);
    }
    function s() {
      var e;
      p("mousemove", document, a), p("mouseup", document, s), (e = t.onComplete) === null || e === void 0 || e.call(t);
    }
    return {
      palleteRef: n,
      handleColor: S(() => {
        const {
          rgba: e
        } = t;
        return e ? `rgb(${e[0]}, ${e[1]}, ${e[2]})` : "";
      }),
      handleMouseDown: h
    };
  },
  render() {
    const {
      clsPrefix: t
    } = this;
    return o("div", {
      class: `${t}-color-picker-pallete`,
      onMousedown: this.handleMouseDown,
      ref: "palleteRef"
    }, o("div", {
      class: `${t}-color-picker-pallete__layer`,
      style: {
        backgroundImage: `linear-gradient(90deg, white, hsl(${this.displayedHue}, 100%, 50%))`
      }
    }), o("div", {
      class: `${t}-color-picker-pallete__layer ${t}-color-picker-pallete__layer--shadowed`,
      style: {
        backgroundImage: "linear-gradient(180deg, rgba(0, 0, 0, 0%), rgba(0, 0, 0, 100%))"
      }
    }), this.rgba && o("div", {
      class: `${t}-color-picker-handle`,
      style: {
        width: l,
        height: l,
        borderRadius: r,
        left: `calc(${this.displayedSv[0]}% - ${r})`,
        bottom: `calc(${this.displayedSv[1]}% - ${r})`
      }
    }, o("div", {
      class: `${t}-color-picker-handle__fill`,
      style: {
        backgroundColor: this.handleColor,
        borderRadius: r,
        width: l,
        height: l
      }
    })));
  }
});
export {
  C as default
};
